import { styled } from "@mui/material";

export const StyledBlackBackground = styled("div")`
  position: absolute;
  background: ${({ theme }) => theme.wsc.palette.neutral[900]};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

interface IStyledStyledVideoContainer {
  showOnHover?: boolean;
  videoBackgroundHoverOpacity: number;
}

export const StyledVideoContainer = styled("div")<IStyledStyledVideoContainer>`
  position: absolute;
  z-index: 10;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;

  ${(props) =>
    props.showOnHover &&
    `
    &:hover {
        > video,
        > div {
        display: flex;
        }
    }

    > video, > div {
        display: none;
    }

    > div {
        opacity: ${props.videoBackgroundHoverOpacity};
    }
  `}

  > video {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
`;

export const StyledLoaderContainer = styled("div")`
  position: relative;
  z-index: 0;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;
